import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoLibrary = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.66665 9.66671L12.3333 6.66671L7.66665 3.66671V9.66671ZM5.33331 12C4.96665 12 4.65276 11.8695 4.39165 11.6084C4.13054 11.3473 3.99998 11.0334 3.99998 10.6667V2.66671C3.99998 2.30004 4.13054 1.98615 4.39165 1.72504C4.65276 1.46393 4.96665 1.33337 5.33331 1.33337H13.3333C13.7 1.33337 14.0139 1.46393 14.275 1.72504C14.5361 1.98615 14.6666 2.30004 14.6666 2.66671V10.6667C14.6666 11.0334 14.5361 11.3473 14.275 11.6084C14.0139 11.8695 13.7 12 13.3333 12H5.33331ZM2.66665 14.6667C2.29998 14.6667 1.98609 14.5362 1.72498 14.275C1.46387 14.0139 1.33331 13.7 1.33331 13.3334V4.00004H2.66665V13.3334H12V14.6667H2.66665Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgVideoLibrary);
export default ForwardRef;
